import { render, staticRenderFns } from "./m-reset-password.vue?vue&type=template&id=1d371b27&scoped=true&"
import script from "./m-reset-password.vue?vue&type=script&lang=js&"
export * from "./m-reset-password.vue?vue&type=script&lang=js&"
import style0 from "./m-reset-password.vue?vue&type=style&index=0&id=1d371b27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d371b27",
  null
  
)

export default component.exports